import React from 'react';
import { connect } from 'react-redux';
import { CheckCircleIcon, PlusIcon } from "@heroicons/react/20/solid";
import { Actions as ACTIONS } from '../../../store/actions/leaveActions';
import OccupationalLeaveRule from './OccupationalLeaveRule';


const OccupationalLeaveRules = ({
    leaveRules,
    disabled,
    addLeaveRule,
}) => {

    return (
        <div className="col-xs-12 form-section">
            <div className="col-xs-12 form-container">
                <div className="pull-left">
                    <h4>Occupational Absence Rules</h4>
                    <p>Add new entitlements here if you'd like to award staff additional days off for the various absence types.</p>
                </div>
                <div className="pull-right">
                    {!disabled &&
                        <button
                            className="btn btn-success pull-right"
                            type="button"
                            id="add-allowance-type"
                            onClick={() => {
                                addLeaveRule()
                            }}
                        >
                            <PlusIcon style={{height: "1.5em", float: "left", marginRight: 5}}/>
                            <div style={{float: "left"}}>Add Absence Rule</div>
                        </button>
                    }
                </div>
            </div>
            {leaveRules?.map((leaveRule,index) => <OccupationalLeaveRule key={leaveRule.id} leaveRule={leaveRule} rowIndex={index}/>)}
        </div>
    )

}


const mapStateToProps = (state) => {

    return {
        leaveRules: state?.leave?.rules ?? [],
        disabled:( state?.permissions?.my?.permissions?.settings == 'Read') || (state?.company?.settings?.status == 'Archived')
    }
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    addLeaveRule: () => dispatch(ACTIONS.addLeaveRule()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OccupationalLeaveRules);